import React from 'react';
import { Container, Grid, Segment } from 'semantic-ui-react';

const FooterLayout = () => (
  <Segment
    inverted
    vertical
    style={{
      backgroundColor: '#006064', marginTop: 'auto', width: '100%',
    }}
  >
    <Container>
      <Grid divided inverted>
        <Grid.Row>
          <Grid.Column width={16} textAlign="center">
            <p>2020 / © Doug Mascotas/ Todos los derechos reservados</p>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Container>
  </Segment>
);

export default FooterLayout;



// WEBPACK FOOTER //
// ./src/layouts/PageLayout/components/FooterLayout.js